<app-modal-shell [config]="modalConfig">
  <form modal-content #equivalenceForm="ngForm" id="equivalence-form" (ngSubmit)="save(equivalenceForm)">
    <fieldset class="equivalence-form" [disabled]="saving">
      <mat-form-field>
        <mat-label>Sección</mat-label>
        <mat-select name="sourceSection" [ngModel]="editing.sourceSection" (ngModelChange)="changeSection($event)" required [disabled]="saving">
          <mat-option *ngFor="let section of sections" [value]="section.value">{{ section.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Valor del Portal</mat-label>
        <input matInput name="sourceValue" [(ngModel)]="editing.sourceValue" required #sourceValue="ngModel">
        <mat-error *ngIf="sourceValue.invalid">Ingresá el valor del Portal.</mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="editing.sourceSection === 'organizationUnits'">
        <mat-label>Nombre en el Portal</mat-label>
        <input matInput name="sourceLabel" [(ngModel)]="editing.sourceLabel" maxlength="250">
      </mat-form-field>
      <mat-checkbox name="ignore" [ngModel]="editing.ignore" (ngModelChange)="changeIgnore($event)" [disabled]="saving">Ignorar al importar</mat-checkbox>
      <p class="form-hint" *ngIf="editing.ignore">Este valor del Portal no se importará a Comunidades.</p>
      <ng-container *ngIf="!editing.ignore">
        <mat-form-field *ngIf="isService">
          <mat-label>Destino</mat-label>
          <mat-select name="targetKind" [ngModel]="editing.targetKind" (ngModelChange)="changeKind($event)" required [disabled]="saving">
            <mat-option value="appointment">Encargo</mat-option>
            <mat-option value="assignment">Nombramiento</mat-option>
            <mat-option value="activity">Colaboración</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="editing.sourceSection !== 'organizationUnits'">
          <mat-label>{{ editing.sourceSection === 'countries' ? 'País en Comunidades' : 'Valor en Comunidades' }}</mat-label>
          <mat-select name="targetId" [(ngModel)]="editing.targetId" (ngModelChange)="editing.activityRoleId = undefined" required #targetId="ngModel" [disabled]="saving">
            <mat-option *ngFor="let option of options" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="targetId.invalid">Elegí el destino en Comunidades.</mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="isService && editing.targetKind === 'activity' && roles.length">
          <mat-label>Rol de colaboración</mat-label>
          <mat-select name="activityRoleId" [(ngModel)]="editing.activityRoleId" [disabled]="saving">
            <mat-option [value]="undefined">Rol predeterminado</mat-option>
            <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="isService">
          <mat-label>Unidad</mat-label>
          <mat-select name="unitRule" [ngModel]="editing.unitRule" (ngModelChange)="changeUnitRule($event)" required [disabled]="saving">
            <mat-option *ngFor="let rule of unitRules" [value]="rule.value">{{ rule.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <app-unit-selector *ngIf="editing.sourceSection === 'organizationUnits' || isService && editing.unitRule === 'specific'"
          name="targetReference" label="Unidad en Comunidades" [(ngModel)]="editing.targetReference" [required]="true" [disabled]="saving">
        </app-unit-selector>
      </ng-container>
    </fieldset>
    <p *ngIf="errorMessage" class="form-error" role="alert">{{ errorMessage }}</p>
  </form>
  <ng-container modal-actions>
    <button mat-button type="button" [disabled]="saving" (click)="dialogRef.close()">Cancelar</button>
    <button mat-raised-button color="primary" type="submit" form="equivalence-form" [disabled]="saving || equivalenceForm.invalid || !editing.sourceValue.trim() || (!editing.ignore && (editing.sourceSection === 'organizationUnits' || isService && editing.unitRule === 'specific') && !editing.targetReference)">
      {{ saving ? 'Guardando...' : 'Guardar' }}
    </button>
  </ng-container>
</app-modal-shell>
